import classNames from 'classnames';
import type React from 'react';
import type { SelectableItem } from '../../../../../../models/CampaignModel';
import { HatMode } from '../../../../../../models/product/HatConfig';

interface Props {
  product: SelectableItem;
  disabled?: boolean;
}

const ProductCardHat: React.FC<Props> = ({ product, disabled }) => {
  const price = product.pricing;

  const {
    displayData: { hatConfig, name },
  } = product;
  const isReduced = price && price.originalPrice > 0 && price.originalPrice > price.price;
  const isRental = name.toLowerCase().includes('leie');

  const getDefaultLabel = () => {
    if (isRental) return 'TV-boks leie';
    if (isReduced && price && price.price === 0 && price.isRecurring) return 'Prøv kostnadsfritt';
    if (isReduced && price && price.price === 0 && !price.isRecurring) return 'Kostnadsfri';
    if (isReduced) return 'Redusert pris';
    return '';
  };

  const getLabel = () => {
    if (!hatConfig) return getDefaultLabel();
    switch (hatConfig.hatMode) {
      case HatMode.Off:
        return '';
      case HatMode.Custom:
        return hatConfig.customHatText;
      default:
        return getDefaultLabel();
    }
  };

  const label = disabled ? 'ikke tilgjengelig' : getLabel();
  const cnames = classNames('tag', 'product-card-hat', { 'product-card-hat--blue': isRental, 'product-card-hat--gray': disabled });
  return (label && <div className={cnames}>{label}</div>) || null;
};

export default ProductCardHat;
